module.exports = __webpack_public_path__ + "static/media/efg.ab8b43e5.svg";